import { addDays } from 'date-fns'

import * as types from '@/store/mutation-types'

import { BookingService } from '@/services'

const getDefaultOrder = ({ amountPeople = 1, date, productId }) => ({
  id: null,

  amountPeople,
  date,

  productId,
  optionId: null,
  scheduleId: null,
  priceId: null,

  price: null,
  startTime: null,
  language: ''
})

const getDefaultCustomer = () => ({
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  message: '',
  countryCode: '',
  countryCallingCode: ''
})

export const state = () => {
  const currentDate = addDays(new Date(), 1)
  currentDate.setHours(0, 0, 0)

  return {
    initDataLoading: true,
    initDataError: null,

    checkAvailabilityLoading: false,
    checkAvailabilityError: null,
    checkAvailabilitySubmitted: false,

    product: null,
    option: null,
    options: [],
    availabilities: [],

    order: getDefaultOrder({ date: currentDate }),

    customer: getDefaultCustomer()
  }
}

export const mutations = {
  [types.SET_OPTION](state, option) {
    state.option = option
  },

  [types.UPDATE_ORDER](state, order) {
    state.order = { ...state.order, ...order }
  },

  [types.CLEAR_ORDER](state) {
    state.order = getDefaultOrder(state.order)
  },

  [types.UPDATE_CUSTOMER](state, customer) {
    state.customer = { ...state.customer, ...customer }
  },

  [types.CLEAR_CUSTOMER](state) {
    state.customer = getDefaultCustomer()
  },

  [types.REQUEST_INIT_DATA](state) {
    state.initDataLoading = true
  },

  [types.REQUEST_INIT_DATA_SUCCESS](state, { product, availabilities }) {
    state.product = product
    state.order.productId = product.id
    state.availabilities = availabilities

    state.initDataLoading = false
  },

  [types.REQUEST_INIT_DATA_ERROR](state, error) {
    state.initDataError = error
    state.initDataLoading = false
  },

  [types.REQUEST_CHECK_AVAILABILITY](state) {
    state.checkAvailabilityLoading = true
  },

  [types.REQUEST_CHECK_AVAILABILITY_SUCCESS](state, { options, option }) {
    state.option = option
    state.options = options
    state.checkAvailabilitySubmitted = true

    state.checkAvailabilityLoading = false
  },

  [types.REQUEST_CHECK_AVAILABILITY_ERROR](state, error) {
    state.options = []

    state.checkAvailabilityError = error
    state.checkAvailabilityLoading = false
  }
}

export const actions = {
  setOption({ commit }, option) {
    commit(types.SET_OPTION, option)
  },

  setAmountPeople({ commit, dispatch, state }, amountPeople) {
    commit(types.UPDATE_ORDER, { amountPeople })

    if (state.checkAvailabilitySubmitted) dispatch('checkAvailability', { amountPeople })
  },

  setDate({ commit, dispatch, state }, date) {
    commit(types.UPDATE_ORDER, { date })

    if (state.checkAvailabilitySubmitted) dispatch('checkAvailability', { date })
  },

  updateOrder({ commit }, order) {
    commit(types.UPDATE_ORDER, order)
  },

  clearOrder({ commit }) {
    commit(types.CLEAR_ORDER)
  },

  updateCustomer({ commit }, customer) {
    commit(types.UPDATE_CUSTOMER, customer)
  },

  clearCustomer({ commit }) {
    commit(types.CLEAR_CUSTOMER)
  },

  async fetchInitData({ commit }, { productId }) {
    commit(types.REQUEST_INIT_DATA)
    try {
      const data = await BookingService.fetchInitData({ productId })
      commit(types.REQUEST_INIT_DATA_SUCCESS, data)
    } catch (e) {
      commit(types.REQUEST_INIT_DATA_ERROR, e)
    }
  },

  async checkAvailability({ state, commit, rootState }, payload = {}) {
    const productId = payload.productId || state.product.id
    const date = payload.date || state.order.date
    const amountPeople = payload.amountPeople || state.order.amountPeople

    commit(types.REQUEST_CHECK_AVAILABILITY)
    try {
      const { options } = await BookingService.checkAvailability({ productId, date, amountPeople })

      const { defaultOptionId } = rootState.app

      const option = options.find(({ id }) => defaultOptionId === id) || options[0]
      const data = { options, option }
      commit(types.REQUEST_CHECK_AVAILABILITY_SUCCESS, data)
    } catch (e) {
      commit(types.REQUEST_CHECK_AVAILABILITY_ERROR, e)
    }
  }
}
